import { Button, ButtonVariant, Intent, Size } from "@blueprintjs/core"
import { useState } from "react"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { Hint, ScalableDialog } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import FieldChanger from "../../landing/landing-edit/FieldChanger"
import { HISTORY_TYPE, IHistoryStep, ILanding } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { LANDING_SCALAR } from "src/modules/pe-landing-module/data/landin_scalars"
import updateHistory from "../../landing/landing-edit/utils/updateHistory"

/* Protopia Ecosystem component */
export interface ICategoriesEditFormProps {
   
}
const CategoriesEditForm = (props: ICategoriesEditFormProps): JSX.Element => {
    const currentLanding: ILanding = useLandingStore( ( state: ILandingStore ) => state.currentLanding )
    const [value, setValue] = useState<any[]>( currentLanding.categories || [] )
    const [isOpen,setIsOpen] = useState<boolean>( false )
    
    const onOpen =() => {
        setIsOpen(true)
    }

    const onUpdate = () => {        
        console.log("value:", value )        
        const newVal:ILanding = JSON.parse(JSON.stringify({
            ...currentLanding,
            categories: value
        }))
        const step:IHistoryStep = {
            data: newVal,
            prevData: currentLanding,
            title: "Update categories",
            type: HISTORY_TYPE.FULL
        }        
        console.log( newVal )        
        updateHistory( step, newVal )
        setIsOpen(false)
    }

    const onChange = ( val: any, field: string, name: string ) => {
        const newVal = val        
        console.log( val, field, name, newVal )        
        setValue( newVal )
    }

    return <>
        <Hint label={ __( "Edit categories" ) }>
            <Button variant={ButtonVariant.MINIMAL} icon="cog" onClick={onOpen} className="pe-surface2"/>
        </Hint>
        <ScalableDialog
            dialogSize={DIALOG_SIZE.NORMAL}
            isOpen={isOpen}
            onClose={() => setIsOpen(false) }
            footer={
                <div className="w-100 d-flex">
                    <Button size={Size.LARGE} intent={Intent.DANGER} onClick={() => setIsOpen(false)}>{__("Close")}</Button>
                    <Button size={Size.LARGE} fill intent={Intent.SUCCESS} onClick={onUpdate}>{__("Update and Close")}</Button>
                </div>
            }
        >
            <div className="p-3">
                <FieldChanger
                    value={currentLanding.categories || []}
                    type="external_array"
                    component={LANDING_SCALAR.CATEGORY}
                    title={"Categories"}
                    subtitle={"Categories"}
                    visualization={"landingCompositeDataType"}
                    required={ false} 
                    editable={true}
                    noDefault={true}
                    onChange={onChange} 
                    dataName=""
                    dataSection="data"

                />
            </div>
        </ScalableDialog>
    </>
}
export default CategoriesEditForm